const setRequestsStatus = (_root, variables, { cache }) => {
    cache.writeData({
        data: { requestsStatus: variables.status },
    });
    return null;
};
export default setRequestsStatus;
